// async
export default {
  alert(context, data) {
    console.log(data);
    data.show = true;
    context.commit('alert', data);
    if (data.duration !== 0) {
      setTimeout(() => {
        context.commit('alert', {
          ...data,
          show: false,
        });
      }, data.duration > 0 ? data.duration : 3000);
    }
  },
  loading(context, show) {
    let data = {
      show
    }
    context.commit('loading', data);
  }
}


// WEBPACK FOOTER //
// ./app/store/actions.js